import { AsmComponentsService, AsmEnvironment } from '../services/asm-components.service';
import { Provider } from '@angular/core';

export function provideAsmComponents(
  environmentName: string,
  apiUrl: string,
  licenseServiceQueryUrl?: string,
  licenseServiceCommandUrl?: string,
  auditLogServiceQueryUrl?: string,
  customerApiUrl?: string,
  smokeTestApiUrl?: string,
  pendoApiKey?: string,
  outscanUrl?: string,
): Provider {
  return {
    provide: AsmComponentsService,
    useFactory: () => {
      return new AsmComponentsService(
        environmentName as AsmEnvironment,
        apiUrl,
        licenseServiceQueryUrl,
        licenseServiceCommandUrl,
        auditLogServiceQueryUrl,
        customerApiUrl,
        smokeTestApiUrl,
        pendoApiKey,
        outscanUrl,
      );
    },
  };
}
